import api from './api';

export const templateApi = {
    // List all templates for a workspace
    getTemplates: async (workspaceId, activeOnly = true) => {
        const response = await api.get(`/api/templates`, {
            headers: { 'x-workspace-id': workspaceId },
            params: { activeOnly }
        });
        return response.data;
    },

    // Get a specific template
    getTemplate: async (workspaceId, id) => {
        const response = await api.get(`/api/templates/${id}`, {
            headers: { 'x-workspace-id': workspaceId }
        });
        return response.data;
    },

    // Create a new template
    createTemplate: async (workspaceId, data) => {
        const response = await api.post(`/api/templates`, data, {
            headers: { 'x-workspace-id': workspaceId }
        });
        return response.data;
    },

    // Update an existing template
    updateTemplate: async (workspaceId, id, data) => {
        const response = await api.put(`/api/templates/${id}`, data, {
            headers: { 'x-workspace-id': workspaceId }
        });
        return response.data;
    },

    // Archive a template
    archiveTemplate: async (workspaceId, id) => {
        const response = await api.delete(`/api/templates/${id}`, {
            headers: { 'x-workspace-id': workspaceId }
        });
        return response.data;
    },

    // Preview a template
    previewTemplate: async (workspaceId, payload) => {
        const response = await api.post(`/api/templates/preview`, payload, {
            headers: { 'x-workspace-id': workspaceId }
        });
        return response.data;
    },

    // Generate AI template (single)
    generateAITemplate: async (workspaceId, payload) => {
        const response = await api.post(`/api/templates/ai-generate`, payload, {
            headers: { 'x-workspace-id': workspaceId }
        });
        return response.data;
    },

    // Generate AI template variations (multiple)
    generateTemplateVariations: async (workspaceId, payload) => {
        const response = await api.post(`/api/templates/ai-generate-variations`, payload, {
            headers: { 'x-workspace-id': workspaceId }
        });
        return response.data;
    }
};

export default templateApi;